import React from 'react';
import DemoPage from './DemoPage';

const LPProspecting: React.FC = () => (
  <DemoPage
    title="LP prospecting"
    videoSrc="/videos/lp_prospecting_demo.mp4"
    description="Find the capital behind every building. Search 176,000+ investors by check size and track record, look up their contact information, and send outreach customized to their investment strategies analyzed by our powerful deal-flow AI in minutes."
  />
);

export default LPProspecting;
